<ion-header>
  <ion-toolbar mode="md">
    <ion-title size="small">
      <ion-text style="font-size: medium">
        {{
          "reservation-app.reservation-send-order-popup.send-order" | translate
        }}</ion-text
      >
    </ion-title>
    <ion-button
      (click)="closeModal()"
      size="small"
      slot="end"
      fill="clear"
      color="dark"
    >
      <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-backdrop
  [visible]="true"
  style="z-index: 1000000; opacity: 0.3"
  *ngIf="createOrderLoadingAnimation"
>
</ion-backdrop>
<ion-grid
  *ngIf="createOrderLoadingAnimation"
  style="
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 1000000000;
  "
>
  <ion-row style="width: 100%; height: 100%">
    <ion-col class="ion-text-center">
      <ion-grid style="max-width: 220px">
        <ng-lottie
          (animationCreated)="animationCreated($event)"
          [options]="animationOptions"
        ></ng-lottie>
      </ion-grid>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-content
  scrollEvents="false"
  scrollX="false"
  [scrollY]="createOrderModalInfoMessage ? true : false"
>
  <ion-grid>
    <ion-item lines="none" *ngIf="dineIn || orderPickup || selectedAddress">
      <ion-label class="ion-text-wrap">
        <div
          *ngIf="
            orderPickup == false && dineIn == true && reservationSelectedDate
          "
        >
          <strong>
            {{
              "reservation-app.reservation-send-order-popup.date" | translate
            }}:
          </strong>
          {{ reservationSelectedDate.date.day | timestampToString }},{{
            reservationSelectedDate.hour
          }}
        </div>
        <div
          *ngIf="orderPickup == false && dineIn == true && selectedDineInTable"
        >
          <strong>
            {{
              "reservation-app.reservation-send-order-popup.table" | translate
            }}:
          </strong>
          {{
            groupApp &&
            groupApp.appointmentsActive &&
            selectedDineInTable.user_name &&
            selectedDineInTable.user_name["el"]
              ? selectedDineInTable.user_name["el"]
              : selectedDineInTable.name
          }}
        </div>

        <div
          *ngIf="
            orderPickup == false &&
            dineIn == true &&
            selectedDineInTable &&
            cart &&
            cart.length &&
            cart[0].service_duration_min
          "
        >
          <strong> {{ "reservation-app.duration" | translate }} </strong>
          {{ cart[0].service_duration_min }}
          {{ "minutes" | translate }}
        </div>

        <div
          *ngIf="
            orderPickup == false &&
            dineIn == true &&
            selectedDineInTable &&
            cart &&
            cart.length &&
            cart[0].name
          "
        >
          <strong> {{ "reservation-app.service" | translate }} </strong>
          <span> {{ cart[0].name }}</span>
        </div>

        <div
          style="font-size: small; line-height: 1.4"
          *ngFor="let coupon of selectedCoupons"
        >
          <strong
            >{{
              coupon.description_langs &&
              (coupon.description_langs[selectedLanguage] ||
                coupon.description_langs[selectedLanguage])
                ? coupon.description_langs[selectedLanguage] ||
                  coupon.description_langs[selectedLanguage]
                : coupon.description_langs && coupon.description_langs[mo_base]
                ? coupon.description_langs[mo_base]
                : coupon.description
            }}{{
              coupon.discount ||
              (coupon.discount_percent && coupon.discount_fixed)
                ? ":"
                : ""
            }}</strong
          >
          <span
            *ngIf="
              coupon.discountType !== 'percent' &&
              coupon.discountType !== 'combined' &&
              coupon.discount
            "
          >
            -{{ coupon.discount }}€
          </span>
          <span *ngIf="coupon.discountType === 'percent' && coupon.discount">
            -{{ coupon.discount }}%
          </span>
          <span
            *ngIf="
              coupon.discountType === 'combined' &&
              coupon.discount_percent &&
              coupon.discount_fixed
            "
          >
            -{{ coupon.discount_percent }}% & -{{ coupon.discount_fixed }}€
          </span>
          <div
            *ngIf="
              cartPrices.discount_amount &&
              coupon &&
              (coupon.discount || coupon.discount_fixed) &&
              coupon.discountType &&
              coupon.discountType !== 'percent' &&
              toFloat(coupon.discount || coupon.discount_fixed) >
                toFloat(cartPrices.discount_amount)
            "
          >
            <ion-text color="danger" style="font-weight: bold">
              {{
                "reservation-app.reservation-send-order-popup.you-have-not-fully-used-you-coupon"
                  | translate
              }}
            </ion-text>
          </div>
        </div>

        <div
          *ngIf="
            cartPrices &&
            ((groupApp &&
              (!groupApp.design_settings ||
                !groupApp.design_settings.hideZeroPrices)) ||
              (groupApp &&
                groupApp.design_settings &&
                groupApp.design_settings.hideZeroPrices &&
                cartPrices.grand_total &&
                cartPrices.grand_total !== '0.00'))
          "
        >
          <strong>
            {{
              "reservation-app.reservation-send-order-popup.total-cost"
                | translate
            }}:
          </strong>

          {{
            cartPrices.grand_total
              | priceWithComma : store_info && store_info.showPricesWithComma
          }}€
        </div>

        <div
          style="margin-top: 3px"
          *ngIf="
            ((groupApp && groupApp.pointsSystem) ||
              (currentUser && currentUser.admin)) &&
            currentOrderPoints
          "
        >
          <ion-badge>
            {{
              "reservation-app.reservation-send-order-popup.you-earn"
                | translate
            }}:
            {{ currentOrderPoints }}
            {{
              "reservation-app.reservation-send-order-popup.points" | translate
            }}
          </ion-badge>
        </div>
      </ion-label>
    </ion-item>

    <div *ngIf="createOrderModalInfoMessage">
      <ion-grid class="ion-text-center ion-no-padding">
        <img
          style="width: 100%"
          src="https://s3-eu-west-1.amazonaws.com/storegroupseditedbgimages/{{
            groupApp.group
          }}/info_messages/{{ createOrderModalInfoMessage.image }}"
        />
      </ion-grid>
      <ion-item
        lines="none"
        *ngIf="
          createOrderModalInfoMessage.title &&
          (createOrderModalInfoMessage.title[selectedLanguage] ||
            createOrderModalInfoMessage.title[mo_base] ||
            createOrderModalInfoMessage.title['en'])
        "
      >
        <ion-label class="ion-text-wrap">
          <div
            [innerHTML]="
              createOrderModalInfoMessage.title[selectedLanguage]
                ? createOrderModalInfoMessage.title[selectedLanguage]
                : createOrderModalInfoMessage.title[mo_base]
                ? createOrderModalInfoMessage.title[mo_base]
                : createOrderModalInfoMessage.title['en']
            "
          ></div>
        </ion-label>
      </ion-item>
    </div>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row *ngIf="loading" style="width: 100%">
      <ion-col style="padding: 0; margin: 0" class="ion-text-center">
        <ion-spinner color="primary"> </ion-spinner>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!loading" style="width: 100%">
      <ion-col style="padding: 0; margin: 0" size="12" class="ion-text-center">
        <ion-button
          shape="round"
          [ngClass]="{
            'animate__animated animate__pulse': animateSendOrderButton
          }"
          size="medium"
          (click)="sendOrder()"
        >
          {{
            "reservation-app.reservation-send-order-popup.send-order-button"
              | translate
          }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
